import { useQuery } from '@tanstack/react-query';
import { useServicesContext } from '../../contexts/ServicesContext';

export enum GetDistributionChannelsCacheKey {
  GetDistributionChannels = 'GetDistributionChannels',
}

export const useGetDistributionChannelsQuery = (teamId?: number) => {
  const { getDistributionChannels } = useServicesContext();
  return useQuery({
    queryKey: [GetDistributionChannelsCacheKey.GetDistributionChannels, teamId],
    queryFn: () => getDistributionChannels(teamId!),
    enabled: Boolean(teamId),
  });
};
